import Signal from 'libs/signals';

const alertSignal = Signal({});

export default alertSignal;
